// extracted by mini-css-extract-plugin
export default {"StackButton":"Shitster_StackButton__89G1o","ControlButton":"Shitster_ControlButton__HeOYe","SongInfo":"Shitster_SongInfo__zlbDm","Position":"Shitster_Position__B9KKh"};